import { isFeatureEnabled } from '../featureToggles.module'

const _getters = {
  canUseGoogleRecaptchaV3: (_, __, ___, rootGetters) => {
    return isFeatureEnabled(rootGetters, 'google-recaptcha-v3')
  },
}

export default _getters
